import { useCallback } from 'react';

import { useIsCustomerSessionReady } from '@order/hooks';

import { useKustomerTokenQuery } from '../../graphql/kustomer.generated';
import { logger } from '../../utils';

/**
 * GraphQL query to fetch Kustomer token from user.
 */
export const useKustomerToken = (isKustomerEnabled: boolean) => {
  const isCustomerSessionReady = useIsCustomerSessionReady();
  const [response, executeQuery] = useKustomerTokenQuery({
    pause: true,
  });
  const kustomerToken = response?.data?.kustomerToken?.token;

  const shouldFetchKustomerToken =
    isKustomerEnabled &&
    isCustomerSessionReady &&
    !kustomerToken &&
    !response?.fetching;

  const fetchKustomerToken = useCallback(() => {
    if (!shouldFetchKustomerToken) return;

    logger.info('Fetching Kustomer Token');
    executeQuery({ requestPolicy: 'network-only' });
  }, [shouldFetchKustomerToken, executeQuery]);

  return {
    kustomerToken,
    fetchKustomerToken,
  };
};
